import Controller from "./cityInvoiceConfiguration.controller";
import template from "./cityInvoiceConfiguration.html";

const cityInvoiceConfiguration = {
  template,
  controller: Controller,
  bindings: {
    cityId: "<",
  },
};

export default cityInvoiceConfiguration;



// WEBPACK FOOTER //
// ./src/components/cityInvoiceConfiguration/cityInvoiceConfiguration.component.js